import { Switch } from 'components/Switch';
import { FlexContainer } from 'components/FlexContainer';

import { Text } from '../styled/Container.styled';

import type { FC } from 'react';

interface PreferenceItemProps {
  title: string;
  description: string;
  onclick: () => void;
  checked: boolean;
  disabled?: boolean;
}

export const PreferenceItem: FC<PreferenceItemProps> = ({
  title,
  description,
  checked,
  disabled,
  onclick,
}) => (
  <FlexContainer justifyContent="space-between" gap={4}>
    <div>
      <Text bold noMargin>
        {title}
      </Text>
      <Text>{description}</Text>
    </div>
    <div>
      <Switch color="lavender" checked={checked} disabled={disabled} onClick={onclick} />
    </div>
  </FlexContainer>
);
